/**
 * This file is to house any api constants, like endpoints, that we need
 */

/**
 * ENDPOINTS
 */
export const addPerson_endpoint         = '/addPerson';
export const checkLiveNow_endpoint      = '/checkLiveNow';
export const getFullService_endpoint    = '/getFullService';
export const getServices_endpoint       = '/getServices';
export const liveStatus_endpoint        = '/liveStatus'; 
export const peopleBasic_endpoint       = '/peopleBasic';
export const saveService_endpoint       = '/saveService';
export const servicePoints_endpoint     = '/servicePoints';
export const services_endpoint          = '/services';
export const setLiveLink_endpoint       = '/setLiveLink';
export const setLiveOn_endpoint         = '/setLiveOn';
export const setliveStatus_endpoint     = '/setLiveStatus';
export const upcomingEvents_endpoint    = '/upcomingEvents';
export const search_endpoint             = '/search';
export const urgentMessage_endpoint      = '/urgentMessage';
export const youtubeServices_endpoint    = '/youtubeServices';
export const youtubeVideos_endpoint      = '/youtubeVideos';
export const youtubeShorts_endpoint      = '/youtubeShorts';
export const gallery_endpoint            = '/getGalleries';
// Distinct from upcomingEvents_endpoint above, which is this site's own
// DB-backed events system (used on the homepage) - this one is sourced
// from Planning Center's Calendar API instead. Deliberately different
// names so the two aren't confused with each other.
export const pcoEvents_endpoint          = '/pcoEvents';
// Events tagged in Planning Center as something other than a regular
// service (conferences, special services, one-off events) - powers the
// public Events page, distinct from pcoEvents_endpoint above.
export const pcoOtherEvents_endpoint     = '/pcoOtherEvents';
// Active announcements pulled from Planning Center's Publishing API,
// replacing the site's own DB-backed announcement list.
export const pcoAnnouncements_endpoint   = '/pcoAnnouncements';
// Congregant portal login - "sign in with Planning Center".
// pcoAuthLogin_endpoint is a full-page redirect target, not a fetch call -
// see congregantPortal/portalLogin.js.
export const pcoAuthLogin_endpoint       = '/auth/pco/login';
export const pcoAuthMe_endpoint          = '/auth/pco/me';